import { defineStyleConfig } from '@chakra-ui/react';

export const ModalStyle = defineStyleConfig({
  baseStyle: {
    dialog: {
      borderRadius: 'xl',
    },
    header: {
      bg: 'neutral.50',
      borderRadius: 'xl',
    },
  },
});
